import { Paginated } from '../common/paginated.fields.js'
import { MediaFields, mediaGQLFields } from '../media/media.fields.js'
import { MemberFields, memberGQLFields } from '../network/member.fields.js'
import {
  SpaceAuthMemberPropsFields,
  spaceAuthMemberPropsGQLFields,
} from '../permission/spaceAuthMemberProps.fields.js'
import { SlateFields, slateGQLFields } from '../slate/slate.fields.js'
import { CollectionFields, collectionGQLFields } from './collection.fields.js'
import {
  HighlightedTagFields,
  highlightedTagGQLFields,
} from './highlightedTag.fields.js'
import {
  SpaceMembersFields,
  spaceMembersGQLFields,
} from './spaceMembers.fields.js'
import { SpacePostsFields, spacePostsGQLFields } from './spacePosts.fields.js'
import {
  SpaceSeoDetailFields,
  spaceSeoDetailGQLFields,
} from './spaceSeoDetail.fields.js'

export type SpaceFields = 'basic' | 'all' | 'default' | CustomSpaceFields
export type PaginatedSpaceFields = Paginated<SpaceFields>

export interface CustomSpaceFields {
  seoDetail?: SpaceSeoDetailFields
  postsCount?: 'basic'
  image?: MediaFields
  banner?: MediaFields
  highlightedTags?: HighlightedTagFields
  createdBy?: MemberFields
  collection?: CollectionFields
  authMemberProps?: SpaceAuthMemberPropsFields
  slate?: SlateFields
  members?: SpaceMembersFields
  posts?: SpacePostsFields
}

const BASIC_SPACE_FIELDS: CustomSpaceFields = {}
const ALL_SPACE_FIELDS: CustomSpaceFields = {
  seoDetail: 'basic',
  postsCount: 'basic',
  image: 'basic',
  banner: 'basic',
  highlightedTags: 'basic',
  createdBy: 'basic',
  collection: 'basic',
  authMemberProps: 'basic',
  slate: 'all',
}
const DEFAULT_SPACE_FIELDS: CustomSpaceFields = {
  authMemberProps: 'all',
  banner: 'basic',
  image: 'basic',
  postsCount: 'basic',
  highlightedTags: 'basic',
  slate: 'all',
  collection: 'basic',
}

export function spaceGQLFields(fields: SpaceFields): string {
  if (fields === 'basic') {
    fields = BASIC_SPACE_FIELDS
  }
  if (fields === 'all') {
    fields = ALL_SPACE_FIELDS
  }
  if (fields === 'default') {
    fields = DEFAULT_SPACE_FIELDS
  }

  return `
    id
    networkId
    name
    description
    slug
    type
    layout
    isHomepage
    address {
      path
      exact
      editable
    }
    createdById
    groupId
    imageId
    bannerId
    membersCount
    createdAt
    updatedAt
    private
    hidden
    inviteOnly
    nonAdminsCanInvite
    customOrderingIndexInGroup
    whoCanPost
    whoCanReact
    whoCanReply
    customSeoDetail {
      description
      noIndex
      thumbnail {
        ${mediaGQLFields()}
      }
      thumbnailId
      title
    }
    relativeUrl
    url
    ${fields.postsCount ? `postsCount` : ``}
    ${
      fields.image
        ? `
      image {
        ${mediaGQLFields(fields.image)}
      }
    `
        : ``
    }
    ${
      fields.banner
        ? `
      banner {
        ${mediaGQLFields(fields.banner)}
      }
    `
        : ``
    }
    ${
      fields.highlightedTags
        ? `
      highlightedTags {
        ${highlightedTagGQLFields(fields.highlightedTags)}
      }

    `
        : ``
    }
    ${
      fields.seoDetail
        ? `
      seoDetail {
        ${spaceSeoDetailGQLFields(fields.seoDetail)}
      }
    `
        : ``
    }
    ${
      fields.createdBy
        ? `
      createdBy {
        ${memberGQLFields(fields.createdBy)}
      }
    `
        : ``
    }
    ${
      fields.collection
        ? `
      collection {
        ${collectionGQLFields(fields.collection)}
      }
    `
        : ``
    }
    ${
      fields.authMemberProps
        ? `
      authMemberProps {
        ${spaceAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``
    }
    ${
      fields.slate
        ? `
        slate {
          ${slateGQLFields('all')}
        }
    `
        : ``
    }
    ${fields.members ? spaceMembersGQLFields(fields.members) : ``}
    ${fields.posts ? spacePostsGQLFields(fields.posts) : ``}
  `
}
